import { createFileRoute } from '@tanstack/react-router';

import { I18nBreadcrumb } from '@/components/ui/i18breadcrumb';
import { getProject } from '@/features/projects/api/projects';

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/'
)({
  loader: async ({ params }) => {
    const data = await getProject(params.projectId);
    return data;
  },
  staticData: { breadcrumb: () => <I18nBreadcrumb translationKey="dashboard" /> },
});
